import { EntityRepository, Repository } from "typeorm";
import { RawMaterial } from "../entities/raw-material.entity";

@EntityRepository(RawMaterial)
export class RawMaterialRepository extends Repository<RawMaterial> {

    
}